theme.headerSticky = (function() {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');

    if (!headerStickyWrapper || !headerStickyTarget) return;

    const setStickyState = () => {
      const headerHeight = headerStickyWrapper.clientHeight;
      document.documentElement.style.setProperty('--header-sticky-offset', `${headerHeight}px`);

      if (window.scrollY > headerHeight) {
        headerStickyTarget.classList.add('sticky');
        document.body.classList.add('has-sticky-header');
      } else {
        headerStickyTarget.classList.remove('sticky');
        document.body.classList.remove('has-sticky-header');
      }
    };

    setStickyState();
    window.addEventListener('scroll', setStickyState);
    window.addEventListener('resize', setStickyState);
  }

  return ScrollSticky;
})();
